import React from 'react';
import type { ComponentProps } from '@components-shared/src/stitches';
import { styled } from '@components-shared/src/stitches';

export function CardLabel({ children, ...props }: ComponentProps<typeof Label>) {
  return <Label {...props}>{children}</Label>;
}

const Label = styled('span', {
  base: 'S',
  fontWeight: 500,
  paddingX: 8,
  paddingY: 4,
  borderRadius: 6,
  variants: {
    color: {
      white: {
        backgroundColor: '$white',
        opacity: 0.9,
      },
      black: {
        backgroundColor: '$black',
        opacity: 0.8,
        color: '$white',
      },
    },
  },
  defaultVariants: {
    color: 'white',
  },
});
